import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import axios from "axios";

import Pagina, {} from "../comun/Pagina";
import SelectorSismos from './SelectorSismos';

import mundo from '../../img/mundo.png';

export default function Pagina0(props) {   
    const onSubmit = (data)=>{
        console.log("data");
        console.log(data);
        props.setState(data);
        props.avanzarPagina();
    }

    const {handleSubmit} = useForm();

    useEffect(() => {
        const probarGuardar = async () => {              
            console.log("inico")      
            const res = await axios.post("http://localhost:4000/sismo_sentido/rest/guardar_formulario/", {
                estado: {
                    fechaSismoAlterna:"20/09/2022 - 03:39 AM",
                    horaSismoAlterna: "1",
                    id_sismo: "SGC2022qdgpxc",
                    id_departamento :11,
                    id_municipio :11001,
                    id_centro_poblado :11001000,
                    balanceo_colgantes :1,
                    perdida_estabilidad :1,
                    descripcion_sismo :"20/09/2022 - 03:39 AM",
                    contacto_nombre :"nombre",
                    actividad :0,
                    sismo_alterno_hora :"01",
                    dano_construccion :1,
                    sismo_alterno_minuto :"00",
                    salio_calle :1,
                    material_construccion :3,
                    sismo_alterno_tarde :"AM",
                    tipo_danos_caida_revest :2,
                    metodo :"procesarDatos",
                    comentarios :"comentario",
                    piso :"2",
                    efectos_naturaleza :"efecto naturaleza",
                    direccion :"direccion prueba",
                    tipo_danos_grietas_revest :1,
                    intensidad_sentida :2,
                    golpeteo_porcelana :1,
                    balanceo_habitacion  :1,
                    contacto_correo :"direccion de correo",                    
                    donde_estaba :1,
                    reaccion_asombro :1,
                    personas_cerca :1
                }
            }).catch(function (error){
                alert("hubo un error")
                console.log("error");
                console.log(error);
            });
            
            console.log("termino")   
            console.log("res.data");
            console.log(res.data);
        };
       
        //probarGuardar();
    }, []);

    return (
        <Pagina
        titulo="Reporta un sismo"
        imgSrc={mundo}
        imgAlt="Globo terraqueo"        
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}        
        explicacion={            
            <div style={{paddingBottom:"4px"}}>
            Lo que reportas por medio de este sencillo formulario le sirve al Servicio Geológico Colombiano para recolectar información relacionada con el área en la que se sintió un sismo y los efectos que
            causó, con el fin de evaluar la intensidad sísmica. Igualmente les permite a los científicos tener un mejor entendimiento del riesgo sísmico en Colombia.
            <br/>
            <br/>
            Tardarás máximo 3 minutos diligenciando el formulario
            </div>        
        }
        contenidoPrincipal= {
            <React.Fragment>
                <div className="TextoMedianoVerde">Por favor selecciona el sismo que sentiste del siguiente listado</div> 
                <SelectorSismos setIdSismo={props.setIdSismo}/>
                <div className="TextoMedianoVerde">Si el sismo que sentiste no está en la lista, haz click <a href="#" onClick={props.irAPaginaAlterna}>aquí</a></div> 
                <button className="BotonAvanzar" onClick={props.avanzarPagina}> Siguiente </button>
                <div className="BarraExplicacion TextoMediano">¡Conoce los sismos sentidos y los resultados generados a partir del formulario de intensidades!</div>
                <button className="BotonAvanzar" onClick={props.irASelectorResultados}>Ver sismos sentidos</button>                
            </React.Fragment>
        }
        />
    );
}